import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Grid,
  Checkbox,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  alert: {
    marginBottom: theme.spacing(3)
  },
  formGroup: {
    marginBottom: theme.spacing(3)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  horizontalPadding: {
    flex: 1,
    margin: theme.spacing(0, 2),
  },
  flexGrow: {
    flexGrow: 1
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  }
}));

const ParkingInfos = props => {
  const { className, parkingInfos, handleFieldChange, isCreation, isAdmin, ...rest } = props;

  const classes = useStyles();

  const handlePriceChange = (event, label, labelAvailability, value) => {
    let formatedPricesAvailability

    const formatedPrice = {
      ...parkingInfos.price,
      [label]: value,
    }

    if (labelAvailability === 'hasHour') {
      if (value !== '') {
        formatedPricesAvailability = {
          ...parkingInfos.pricesAvailability,
          hasHourDay: parkingInfos.pricesAvailability.hasHourDay || !parkingInfos.pricesAvailability.hasHourNight,
          hasHourNight: parkingInfos.pricesAvailability.hasHourNight || !parkingInfos.pricesAvailability.hasHourDay,
        }
      } else {
        formatedPricesAvailability = {
          ...parkingInfos.pricesAvailability,
          hasHourDay: false,
          hasHourNight: false,
        }
      }
    } else {
      formatedPricesAvailability = {
        ...parkingInfos.pricesAvailability,
        [labelAvailability]: value !== '',
      }
    }
    handleFieldChange(event, 'price', formatedPrice)
    handleFieldChange(event, 'pricesAvailability', formatedPricesAvailability)
  }

  const handleHourCheckbox = (toggleCheckbox: string) => {
    let hourState = {
      hasHourDay: false,
      hasHourNight: false,
    }
    if (toggleCheckbox === 'hasHourDay') {
      if ((parkingInfos.pricesAvailability.hasHourDay && parkingInfos.pricesAvailability.hasHourNight) ||
          (!parkingInfos.pricesAvailability.hasHourDay)) {
        hourState = {
          hasHourDay: true,
          hasHourNight: false,
        }
      } else if (parkingInfos.pricesAvailability.hasHourDay) {
        hourState = {
          hasHourDay: true,
          hasHourNight: true,
        }
      }
    } else {
      if ((parkingInfos.pricesAvailability.hasHourDay && parkingInfos.pricesAvailability.hasHourNight) ||
          (!parkingInfos.pricesAvailability.hasHourNight)) {
        hourState = {
          hasHourDay: false,
          hasHourNight: true,
        }
      } else if (parkingInfos.pricesAvailability.hasHourNight) {
        hourState = {
          hasHourDay: true,
          hasHourNight: true,
        }
      }
    }
    const pricesAvailability = {
      ...parkingInfos.pricesAvailability,
      ...hourState,
    }
    handleFieldChange(null, 'pricesAvailability', pricesAvailability)
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Parking Infos" />
      <CardContent>
        <div className={classes.formGroup}>
          <TextField
            className={classes.field}
            fullWidth
            label="Is Available"
            margin="dense"
            name="isAvailable"
            onChange={event => handleFieldChange(event, 'isAvailable', event.target.value)}
            select
            // eslint-disable-next-line react/jsx-sort-props
            SelectProps={{ native: true }}
            value={parkingInfos.isAvailable}
            variant="outlined"
          >
            <option disabled value=""/>
            <option value={true} label="Yes"></option>
            <option value={false} label="No"></option>
          </TextField>
        </div>
        <div className={classes.formGroup}>
          <TextField
            fullWidth
            label="Parking Name"
            name="name"
            onChange={event =>
              handleFieldChange(event, 'name', event.target.value)
            }
            value={parkingInfos.name}
            variant="outlined"
            required
          />
        </div>
        <div className={classes.formGroup}>
          <TextField
            fullWidth
            label="Parking Address"
            name="address"
            onChange={event =>
              handleFieldChange(event, 'address', event.target.value)
            }
            value={parkingInfos.address}
            variant="outlined"
            required
          />
        </div>
        <div className={classes.formGroup}>
          <TextField
            fullWidth
            label="City"
            name="city"
            onChange={event =>
              handleFieldChange(event, 'city', event.target.value)
            }
            value={parkingInfos.city}
            variant="outlined"
            required
          />
        </div>
        <div className={classes.formGroup}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Max Height"
                name="maxHeight"
                onChange={event =>
                  handleFieldChange(event, 'maxHeight', event.target.value)
                }
                value={parkingInfos.maxHeight}
                variant="outlined"
                required
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Total parking spaces"
                name="totalSpaces"
                onChange={event =>
                  handleFieldChange(event, 'totalSpaces', event.target.value)
                }
                value={parkingInfos.totalSpaces}
                variant="outlined"
                required
              />
            </Grid>
          </Grid>
        </div>
        <div className={classes.formGroup}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="Price per Month"
                name="pricePerMonth"
                onChange={event =>
                  handlePriceChange(event, 'month', 'hasMonth', event.target.value)
                }
                value={parkingInfos.price.month || ''}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="Price per Day"
                name="pricePerDay"
                onChange={event =>
                  handlePriceChange(event, 'day', 'hasDay', event.target.value)
                }
                value={parkingInfos.price.day || ''}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="Price per Hour"
                name="pricePerHour"
                onChange={event =>
                  handlePriceChange(event, 'hour', 'hasHour', event.target.value)
                }
                value={parkingInfos.price.hour || ''}
                variant="outlined"
              />
              <Grid container spacing={2}>
                <Grid item md={6} xs={6}>
                  <Grid container alignItems="center">
                    <Checkbox checked={parkingInfos.pricesAvailability.hasHourDay && !parkingInfos.pricesAvailability.hasHourNight} onChange={() => { handleHourCheckbox('hasHourDay')}} value="hasHourDay" />
                    <Typography variant="h6">Only day</Typography>
                  </Grid>
                </Grid>
                <Grid item md={6} xs={6}>
                  <Grid container alignItems="center">
                    <Checkbox checked={!parkingInfos.pricesAvailability.hasHourDay && parkingInfos.pricesAvailability.hasHourNight} onChange={() => { handleHourCheckbox('hasHourNight')}} value="hasHourNight" />
                    <Typography variant="h6">Only night</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className={classes.formGroup}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Latitude"
                name="longitude"
                onChange={event =>
                  handleFieldChange(event, 'latitude', event.target.value)
                }
                value={parkingInfos.latitude}
                variant="outlined"
                disabled={!isCreation}
                required
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Longitude"
                name="longitude"
                onChange={event =>
                  handleFieldChange(event, 'longitude', event.target.value)
                }
                value={parkingInfos.longitude}
                variant="outlined"
                disabled={!isCreation}
                required
              />
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

ParkingInfos.propTypes = {
  isAdmin: PropTypes.bool,
  isCreation: PropTypes.bool,
  parkingInfos: PropTypes.object,
  handleFieldChange: PropTypes.func,
  className: PropTypes.string
};

export default ParkingInfos;
